import { atom, useAtom } from 'jotai';
import { TurnaroundListFilters } from 'api/models/TurnaroundList';

export const TURNAROUND_LIST_INITIAL_FILTERS: TurnaroundListFilters = {
  offset: '0',
  limit: '10',
};

const turnaroundListFiltersAtom = atom(TURNAROUND_LIST_INITIAL_FILTERS);

export const useTurnaroundListFilters = () => useAtom(turnaroundListFiltersAtom);
